import React from "react";

const FAQ = () => {
  return (
    <section id="faq" className="container">
      <span className="section-caption">FAQ</span>
      <h2 className="mb-5">
        Got Questions?
        <br />
        Look here.
      </h2>
      <div className="grid">
        <div className="g-col-md-8 g-col-12 g-start-md-3">
          <div className="accordion" id="accordionExample">
            <div className="accordion-item">
              <h3 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  What devices is Daysketcher compatible with?
                </button>
              </h3>
              <div
                id="collapseOne"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  Daysketcher is cross-platform, which means it will be
                  available on iOS and Android.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h3 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  Why are some features missing or limited right now?
                </button>
              </h3>
              <div
                id="collapseTwo"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  Daysketcher is still growing! We are actively building new features based on user feedback. What you see now is just the beginning.
                  Many powerful tools and improvements are on the way. We appreciate your patience and support as we continue to develop the app.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h3 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseThree"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  Is Daysketcher free?
                </button>
              </h3>
              <div
                id="collapseThree"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  The app is now available on the App Store and Google Play. Right now, you can enjoy free access to all features.
                  Later, we will introduce a subscription model, but for now, everything is completely free to explore.
                  A free version will always be available, although some features may become limited in the future.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h3 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseSix"
                  aria-expanded="false"
                  aria-controls="collapseSix"
                >
                  Can Daysketcher help me with mental health issues?
                </button>
              </h3>
              <div
                id="collapseSix"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  While Daysketcher is not a replacement for professional mental
                  health treatment, it can be a helpful tool for improving
                  overall well-being and managing stress and anxiety. Users with
                  mental health concerns should seek professional help in
                  addition to using the app.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
